/**
 * FastAPI
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum PreventionListMeasureOrderingEnum {
    Title = 'title',
    TitleDesc = 'title-desc'
}

